import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml:
    "To answer this research question a listening experiment in VR is conducted. The participants are asked to do a memory test, where they need to remember nine digits in a random order, as it is seen in the video below. This memory test is done by the participants for different noise conditions. In this way the researchers can evaluate the cognitive performance of the participants for the tested situations.</br>To guarantee that the different noise conditions are auralized according to a realistic situation, the reproduction of the sound via headphones needs to be equalized and set to a certain sound pressure level at the ear of the participants.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/03/27/principle/principle-02.mp4`,
            },
          },
          styles: {
            padding: "3.46% 2%",
          },
        },
      },
    },
  },
};

export default principle;
